import React, { useEffect, useState } from 'react';
import styles from './testProgress.module.scss';
import classNames from 'classnames/bind';
import { CommonCard } from '../../common/card';
import Webcam from '../../common/webcam/Webcam';
import NoSsr from '@common/noSsr';
import { RESOLUTION } from '@domain/constant/webcamTypes';
import useInterviewPracticeStore from '@stores/InterviewStore/InterviewPracticeStore';
import { shallow } from 'zustand/shallow';

const cx = classNames.bind(styles);

export const TestProgress = () => {
  const startTest = useInterviewPracticeStore((state) => state.startTest);
  const recorderService = useInterviewPracticeStore((state) => state.recorderService, shallow);
  const micScale = useInterviewPracticeStore((state) => state.micScale);
  const timer = useInterviewPracticeStore((state) => state.timer, shallow);
  const toNextStep = useInterviewPracticeStore((state) => state.practiceStepInfo.toNextStep, shallow);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    setTimeout(() => setEnabled(true), 100);
    setTimeout(() => {
      (async () => {
        await startTest();
        setTimeout(() => setEnabled(false), 100);
        setTimeout(() => toNextStep(), 600);
      })();
    }, 600);
  }, []);

  return (
    <CommonCard className={cx('card', { enabled })}>
      <div className={cx('header')}>
        <div className={cx('title')}>“안녕하세요. 만나서 반갑습니다.”</div>
        <div className={cx('guide')}> 5초 이내에 위 문구를 모두 읽어주세요.</div>
      </div>
      <div className={cx('webcamContainer')}>
        <NoSsr>
          <Webcam
            className={cx('webcam')}
            stream={recorderService.recorder?.stream ?? null}
            initialized={recorderService.recorder !== null}
            micActive={micScale > 10}
            leftTime={timer.decreasingTime}
          />
        </NoSsr>
      </div>
    </CommonCard>
  );
};
